// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import store from './store';
import element from 'element-ui';
import '@/styles/base.css'
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss'
import '@/styles/css.css'
import '@/styles/myIcon.css'
import '@/utils/clamp';
import '@/config/methods'; // 全局的js方法
import axios from 'axios';
import md5 from 'js-md5';
import { UTable, UTableColumn } from 'umy-ui'; // 第三方虚拟表格插件
Vue.component(UTable.name, UTable);
Vue.component(UTableColumn.name, UTableColumn);
import { getStorage, setStorage } from "@/service/auth.js";

let echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/map');
// 引入饼状图组件
require('echarts/lib/chart/pie');
// 引入折线图组件
require('echarts/lib/chart/line');
// 引入缩放
require('echarts/lib/component/dataZoom');
// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/legend');
require('echarts/extension/bmap/bmap');
import '../static/ueditor-1.4.3.3/ueditor.config.js'
import '../static/ueditor-1.4.3.3/ueditor.all.js'
import '../static/ueditor-1.4.3.3/lang/zh-cn/zh-cn.js'
import '../static/ueditor-1.4.3.3/ueditor.parse.min.js'
Vue.prototype.$echarts = echarts; //引入组件

Vue.prototype.$md5 = md5;
Vue.prototype.$http = axios;
import maximg from '@/components/MaxImg';
Vue.component("maximg", maximg);
//ajax
import qs from 'qs';
import querystring from 'querystring'
import request from '@/service/request'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$qs = qs;
Vue.prototype.$request = request;
import AllPagination from './components/AllPagination/index';
Vue.use(AllPagination);
import Pagination from './components/Pagination/index';
Vue.use(Pagination);
import FormPanel from './components/FormPanel/index';
Vue.use(FormPanel);
import Steps from './components/Steps/index';
Vue.use(Steps);
import UploadFile from './components/UploadFile/index';
Vue.use(UploadFile);
import MaxImg from './components/MaxImg/index';
Vue.use(MaxImg);
import PreviewFiles from './components/PreviewFiles/index';
Vue.use(PreviewFiles);
import TableTextareaCell from './components/TableTextareaCell/index';
Vue.use(TableTextareaCell);
import Tinymce from './components/Tinymce/index';
Vue.use(Tinymce);
import Score from './components/Score/index';
Vue.use(Score);
import '../static/ueditor-1.4.3.3/ueditor.config.js'
import '../static/ueditor-1.4.3.3/ueditor.all.min.js'
import '../static/ueditor-1.4.3.3/lang/zh-cn/zh-cn.js'
import '../static/ueditor-1.4.3.3/ueditor.parse.min.js'

//全局函数
import Storage from '@/service/auth.js'
Vue.prototype.$Storage = Storage;
//执行
Vue.use(element, { size: 'small' });
//要求所有el-dialog不允许点击modal自动关闭，这里设置为默认
element.Tree.props.accordion.default = true;
element.Dialog.props.closeOnClickModal.default = false;
element.Dialog.props.closeOnPressEscape.default = false;
// element.Dialog.props.showClose.default = false;
element.Dialog.props.appendToBody.default = true
Vue.config.productionTip = false
console.log(window.location.host)
// 唐吉后台
// dev https://apidev.interhouse.cn => https://lapi.interhouse.cn/dev/bim/ https://lapi.interhouse.cn/dev/mall/
// test https://apitest.interhouse.cn => https://lapi.interhouse.cn/test/bim/ https://lapi.interhouse.cn/test/mall/
// stage https://apistage.interhouse.cn => https://api2.interhouse.cn/stage/bim/ https://api2.interhouse.cn/stage/mall/
// online https://api.interhouse.cn => https://api2.interhouse.cn/bim/ https://api2.interhouse.cn/mall/
switch (window.location.hostname) {
  case "localhost":
    Vue.prototype.$proxyurl = window.location.origin + '/bim/';
    Vue.prototype.$url = "https://lapi.interhouse.cn/local/bim";
    Vue.prototype.img_oss = 'https://osstest.interhouse.cn/';
    Vue.prototype.$env = 'test';
    break;
  case "tjdev.interhouse.cn":
    Vue.prototype.$proxyurl = window.location.origin + '/bim/';
    Vue.prototype.$url = "https://lapi.interhouse.cn/dev/bim";
    Vue.prototype.img_oss = 'https://osstest.interhouse.cn/';
    Vue.prototype.$env = 'dev';
    break;
  case "tjtest.interhouse.cn":
    Vue.prototype.$proxyurl = window.location.origin + '/bim/';
    Vue.prototype.$url = "https://lapi.interhouse.cn/test/bim";
    Vue.prototype.img_oss = 'https://osstest.interhouse.cn/';
    Vue.prototype.$env = 'test';
    break;
  case "tjstage.interhouse.cn":
    Vue.prototype.$proxyurl = window.location.origin + '/bim/';
    Vue.prototype.$url = "https://api2.interhouse.cn/stage/bim";
    Vue.prototype.img_oss = 'https://stageoss.interhouse.cn/';
    Vue.prototype.$env = 'stage';
    break;
  case "tj.interhouse.cn":
    Vue.prototype.$proxyurl = window.location.origin + '/bim/';
    Vue.prototype.$url = "https://api2.interhouse.cn/bim";
    Vue.prototype.img_oss = 'https://onlineoss.interhouse.cn/';
    Vue.prototype.$env = 'online';
    break;
  default:
    Vue.prototype.$proxyurl = window.location.origin + '/bim/';
    Vue.prototype.$url = "https://api2.interhouse.cn/bim";
    Vue.prototype.img_oss = 'https://onlineoss.interhouse.cn/';
    Vue.prototype.$env = 'online';
}

// Vue.prototype.$proxyurl = Vue.prototype.$url;
router.beforeEach((to, from, next) => {

  if (to.meta.title) {
    document.title = to.meta.title;
  };
  setStorage('fromFullPath', from.fullPath);
  next();
});
Vue.prototype.allshrink = function (m) {
  for (var i = 0; i < m.store._getAllNodes().length; i++) {
    m.store._getAllNodes()[i].expanded = false;
  };
  m.setCurrentKey(null);
};
Vue.prototype.clearFileInput = function (m) {
  let file = document.getElementById(m);
  var form = document.createElement('form');
  document.body.appendChild(form);
  //记住file在旧表单中的的位置
  var pos = file.nextSibling;
  form.appendChild(file);
  form.reset();
  pos.parentNode.insertBefore(file, pos);
  document.body.removeChild(form);
};
/* eslint-disable no-new */
import VueCompositionApi from '@vue/composition-api'

Vue.use(VueCompositionApi)
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js